import {
  Grid,
  Icon,
  Avatar as MuiAvatar,
  Typography,
} from '@mui/material';

import './FileViewer.scss';
import * as Functions from '../../utils/functions';
import * as Constants from '../../utils/constants';

const key = 'FileViewer';

const FileViewer = props => {
  const {
    file,
    size = { width: '100%', height: '100%' },
    disablePlayer,
    useOriginalQuality,

    onAdapterClick,
  } = props;

  const _file = Functions.Filer.makeAdapterFile(file);

  return (
    <>
      <Typography component={'section'} className={key} sx={size} onClick={onAdapterClick}>
        {
          (_file?.adapter.fileTypeCode === Constants.File.FileType.Image.code) &&
          <img
            className="file-image MuiImageListItem-img"
            src={useOriginalQuality ? _file?.adapter.url : _file?.adapter.thumbnailUrl}
            alt={_file?.adapter.displayName}
            loading="lazy"
            style={{height: size.height}}
          />
        }

        {
          (_file?.adapter.fileTypeCode === Constants.File.FileType.Audio.code) &&
          <>
            {
              disablePlayer ?
                <MuiAvatar
                  className="file-avatar"
                  variant={'square'}
                >
                  <Icon className='icon'>{'audiotrack'}</Icon>
                </MuiAvatar> :
                <div className="file-audio">
                  <audio controls>
                    <source src={_file?.adapter.url} type="audio/mp3" />
                    Your browser does not support the audio element.
                  </audio>
                </div>
            }
          </>

        }

        {
          (_file?.adapter.fileTypeCode === Constants.File.FileType.Video.code) &&
          <>
            {
              disablePlayer ?
                <MuiAvatar
                  className="file-avatar"
                  variant={'square'}
                >
                  <Icon className='icon'>{'movie'}</Icon>
                </MuiAvatar> :
                <div className="file-video">
                  <video preload="metadata" controls={true}>
                    <source src={_file?.adapter.url + '#t=0.1'} type="video/mp4" />
                    Your browser does not support the video element.
                  </video>
                </div>
            }
          </>
        }

        {
          (_file?.adapter.fileTypeCode === Constants.File.FileType.Other.code) &&
          <>
            <Grid
              className="file-other"
              container
              wrap={'nowrap'}
              alignItems='center'
              justifyContent='center'
              spacing={1}
            >

              <Grid size={{ xs: 4 }}>
                <MuiAvatar
                  className="file-avatar"
                  variant={'square'}
                >
                  <Icon className='icon'>{'image'}</Icon>
                </MuiAvatar>
              </Grid>

              <Grid className='info' size={{ xs: 8 }}>
                <div className='file-name dot-overflow'>{_file?.adapter.displayName}</div>
              </Grid>

            </Grid>
          </>
        }
      </Typography>
    </>
  );
};

export default FileViewer;